import { DEFAULT_TEXT_WIDTH as r, DEFAULT_FONT_SIZE as u, DEFAULT_LINE_HEIGHT as n } from "./atoms-v21301.js";
function T(e, t) {
  return !e.text && !e.defaultTextWidth ? `${r}px` : e.text ? t ? `${t.measureText(e.text).width}px` : `${e.defaultTextWidth}px` : `${e.defaultTextWidth}px`;
}
function a(e) {
  switch (e.fontWeight) {
    case 100:
    case 200:
    case 300:
      return "light";
    case 500:
    case 600:
      return "bold";
    case 700:
    case 800:
    case 900:
      return "heavy";
    default:
      return "regular";
  }
}
function c(e) {
  return `${a(e)} ${e.fontSize ?? u}px ${e.fontFamily}`;
}
function h(e) {
  return `${(e.lineHeight ?? n) * (e.lineCount ?? 1)}px`;
}
export {
  c as getFont,
  a as getFontWeightStr,
  h as getTextHeight,
  T as measureText
};
